// extracted by mini-css-extract-plugin
module.exports = {"productSliderContainer":"product-slider_productSliderContainer__wanZt"};